"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getValidationProps = exports.shouldIconDisplay = exports.shouldMessageDisplay = exports.isFieldVisiblyInvalid = exports.getFieldValidationMessage = exports.getFieldValidType = exports.showMaxLengthCounter = exports.optionsPropTypes = exports.getAllFieldElementIds = exports.boolToString = void 0;

var _fieldUtils = _interopRequireWildcard(require("../microFields/fieldUtils"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

// Pass-through base functions
var boolToString = _fieldUtils.boolToString;
exports.boolToString = boolToString;
var getAllFieldElementIds = _fieldUtils.getAllFieldElementIds;
exports.getAllFieldElementIds = getAllFieldElementIds;
var optionsPropTypes = _fieldUtils.optionsPropTypes; // Adapted functions

/**
 * True or false whether to show the Max Length Counter.
 *
 * @param  {Object} field - the formik field object
 * @param  {Number} maxLength - the maxLength of the input
 * @return {boolean}
 */

exports.optionsPropTypes = optionsPropTypes;

var showMaxLengthCounter = function showMaxLengthCounter(field, maxLength) {
  return _fieldUtils.showMaxLengthCounter(field.value, maxLength);
};
/**
 * Get one of (ERROR, WARNING or VALID) depending on the validation status of the field.
 *
 * @param  {Object} field - the formik field object
 * @param  {Object} form - the formik form object
 * @param  {boolean} [showCounter=false] - (optional)
 * @return {String} the current state of field validation
 *                      ERROR or WARNING or VALID
 */


exports.showMaxLengthCounter = showMaxLengthCounter;

var getFieldValidType = function getFieldValidType(field, form) {
  var showCounter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var isInvalid = !form.isValid;
  var fieldName = field.name;
  var warningMessage = form.status && form.status.warnings ? form.status.warnings[fieldName] : null;
  return _fieldUtils.getFieldValidType(isInvalid, warningMessage, showCounter);
};
/**
 * One message at a time -> prioritize error over warnings
 *
 * @param  {Object} field - the formik field object
 * @param  {Object} form - the formik form object
 * @return {String} translated message to be displayed
 */


exports.getFieldValidType = getFieldValidType;

var getFieldValidationMessage = function getFieldValidationMessage(field, form) {
  var isInvalid = !form.isValid;
  var fieldName = field.name;
  var warningMessage = form.status && form.status.warnings ? form.status.warnings[fieldName] : null;
  var errorMessage = form.errors[fieldName];
  return _fieldUtils.getFieldValidationMessage(isInvalid, warningMessage, errorMessage);
};
/**
 * True or false as to whether the field meets the criteria for displaying as invalid.
 *
 * @param  {Object} field - the formik field object
 * @param  {Object} form - the formik form object
 * @param  {boolean} [showUntouchedErrors=false] - (optional) whether or not to show errors
 *      on fields that have not been touched
 * @return {boolean} whether the field has been interacted with and is invalid
 */


exports.getFieldValidationMessage = getFieldValidationMessage;

var isFieldVisiblyInvalid = function isFieldVisiblyInvalid(field, form) {
  var showUntouchedErrors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var isInvalid = !form.isValid;
  var fieldName = field.name;
  var isTouched = form.touched[fieldName];
  return _fieldUtils.isFieldVisiblyInvalid(isInvalid, isTouched, showUntouchedErrors);
};
/**
 * True or false as to whether the field meets criteria for displaying an error or warning.
 *
 * This checks for whether the field is invalid and has been interacted with (when we care based on showUntouchedErrors)
 * OR there is a warning message provided (therefore don't wait for the field to be touched)
 *
 * @param  {Object} field - the formik field object
 * @param  {Object} form - the formik form object
 * @param  {boolean} [showUntouchedErrors=false] - (optional) whether or not to show errors
 *                                                  on fields that have not been touched
 * @return {boolean} should show error or warning message
 */


exports.isFieldVisiblyInvalid = isFieldVisiblyInvalid;

var shouldMessageDisplay = function shouldMessageDisplay(field, form) {
  var showUntouchedErrors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var isInvalid = !form.isValid;
  var fieldName = field.name;
  var isTouched = form.touched[fieldName];
  var warningMessage = form.status && form.status.warnings ? form.status.warnings[fieldName] : null;
  return _fieldUtils.shouldMessageDisplay(isInvalid, isTouched, showUntouchedErrors, warningMessage);
};
/**
 * True or false whether the field meets the criteria for displaying a validation icon.
 *
 * This checks for whether the field has been interacted with so we don't
 * show an icon on an empty and valid(optional) field.
 *
 * @param  {Object} field - the formik field object
 * @param  {Object} form - the formik form object
 * @param  {boolean} [showCounter=false] - (optional) whether to show a counter by the field or not
 * @return {boolean}
 */


exports.shouldMessageDisplay = shouldMessageDisplay;

var shouldIconDisplay = function shouldIconDisplay(field, form) {
  var showCounter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var fieldName = field.name;
  var isTouched = form.touched[fieldName];
  return _fieldUtils.shouldIconDisplay(field.value, form.isValid, isTouched, showCounter);
};
/**
 * Get a set of properties helping describe the validation state of the field from a
 * UI perspective (i.e. whether to show a message, icon, type of icon, etc)
 *
 * @param  {Object} field - the formik field object
 * @param  {Object} form - the formik form object
 * @param  {boolean} [showCounter=false] - (optional) whether the field has a maxLength counter
 * @param  {boolean} [showUntouchedErrors=false] - (optional)
 * @return {Object} object with the following shape:
 *      isInvalid - @see isFieldVisiblyInvalid
 *      showMessage - @see shouldMessageDisplay
 *      showIcon - @see shouldIconDisplay
 *      type - @see getFieldValidType
 *      message - @see getFieldValidationMessage
 */


exports.shouldIconDisplay = shouldIconDisplay;

var getValidationProps = function getValidationProps(field, form) {
  var showCounter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var showUntouchedErrors = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  return {
    isInvalid: isFieldVisiblyInvalid(field, form, showUntouchedErrors),
    showMessage: shouldMessageDisplay(field, form, showUntouchedErrors),
    showIcon: shouldIconDisplay(field, form, showCounter),
    type: getFieldValidType(field, form, showCounter),
    message: getFieldValidationMessage(field, form)
  };
};

exports.getValidationProps = getValidationProps;